import React, {Component} from "react";
import {Link} from "react-router-dom";
import PackageExpired from "../layouts/PackageExpired";
import HeaderRight from "../layouts/HeaderRight";
import Constent from '../../networking/Constent';
import {post} from './../../networking/Api'
import {Alert} from "./../../alertServices";
import helpers from './../../networking/Helpers';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import CheckinPopup from "../timeregistration/CheckinPopup";
import {
    PullToRefresh,
    PullDownContent,
    ReleaseContent,
    RefreshContent
  } from "react-js-pull-to-refresh";

var location='';
class DeviceTimestamp extends Component {
    constructor(props) {
      super(props);
      this.state={
            user_list2:[],
            selected_user:'',
            selected_user_ary : [],
          timestamp_data:[],
          timestamp_details: [],
          share_device_data : [],
          total_count : -1,
          is_loading : false,
          select_dropdown:'',
          total_time  :'',
          user_image :'',
           date:helpers.getCurrentDate(),
           selected_date:helpers.getCurrentDate(),
           enable_next_button : true,
           
           meeting_date:'',
           meeting_time:'',
           leaving_date:'',
           leaving_time:'',
           note:'',
           timestamp_id : '', 
           timestamp_detail_id:'',
           user_id:'',

           device_list : [],
           total_terminal:0,
           terminal_primary_key:'',
           terminal_id:'',
           terminal_description : '',
           to_do : '',
           export_type : '',
           password:'',

            user_list: [],
            message : '',
            emp_edit:1,
            guest_share_id :'',
            guest_status:1,
            guest_permission:1,
            is_device_online:0,
            custom_date:'',
            grand_total_time: '00:00'
        }
        this.handleChange = this.handleChange.bind(this);  
        this.handleRefresh = this.handleRefresh.bind(this);

    }

    handleRefresh() {
        return new Promise(resolve => {
            this.getTimeStampList(this.state.selected_date, resolve);
            this.getDeviceList();
            this.getContactList();
        });
    }

    componentDidMount(){
        localStorage.setItem('temp_data', JSON.stringify([]));
        if(this.state.terminal_id === ''){
            let termianl_id = (localStorage.getItem('active_terminal') === null) ? '' : JSON.parse(localStorage.getItem('active_terminal')).terminal_unique_id;
            let terminal_description = (localStorage.getItem('active_terminal') === null) ? '' : JSON.parse(localStorage.getItem('active_terminal')).terminal_description;
            let to_do = (localStorage.getItem('active_terminal') === null) ? '' : JSON.parse(localStorage.getItem('active_terminal')).to_do;
            this.setState({terminal_id:termianl_id,terminal_description:terminal_description, to_do:to_do});
        }


        let guest_write_access = 1;
        this.setState({guest_write_access:guest_write_access})

        let timestamp_option = localStorage.getItem('timestamp_option');
        let timesoption=JSON.parse(timestamp_option);
        this.getTimeStampList(this.state.selected_date);
        this.getDeviceList();
          if(timesoption.date_filter==="monthly"){
              this.setState({date_range:30})
          }
          if(timesoption.date_filter==="weekly"){
              this.setState({date_range:7})
          }
          if(timesoption.date_filter==="2_weekly"){
              this.setState({date_range:14})
          }
          if(timesoption.date_filter==="3_monthly"){
              this.setState({date_range:90})
          } 

        if(localStorage.getItem('user_type') !== 'department'){  
            this.setState({
                emp_edit:timesoption.guest_setting.emp_edit
            });
        }
        this.getContactList();
    }

    enableNextButton(endDate){
        var todayDate = helpers.getCurrentDate();

        endDate = moment(endDate, 'YYYY-MM-DD');
        todayDate = moment(todayDate, 'YYYY-MM-DD');
        if (endDate.isBefore(todayDate)) {
            this.setState({'enable_next_button':true});
        }else{
            this.setState({'enable_next_button':false});
        }
    }

    startdt=()=>{
        var str=this.state.selected_date;
        str= str.split("-"); //convert 'jQuery' to array
        str = str.reverse(); //reverse 'jQuery' order 
        str = str.join("/");
        return str;
    }
    enddt=()=>{
        var str=this.state.selected_date;
        str= str.split("-"); //convert 'jQuery' to array
        str = str.reverse(); //reverse 'jQuery' order 
        str = str.join("/");
        return str;
    }

    getContactList(){
        var user_id= localStorage.getItem('userid');
        var formData = new FormData();
        formData.append("user_id",user_id);
        post(Constent.CONTACT,formData).then(response=>{
          if(response.status){
           this.setState({user_list2:response.user_list });
          }else{
            Alert.error({title: response.message});
          }
        })
    }

    handleChange(event) {
        var isChecked = event.target.checked;
        var id = event.target.value;
       
        var tempdata = JSON.parse(localStorage.getItem('temp_data'));
        if(isChecked){
            tempdata =  tempdata.concat(id);
        }else{
            var array = tempdata; // make a separate copy of the array
            var index = array.indexOf(id);
            if (index !== -1) {
                array.splice(index, 1);
            }
            tempdata = array;
        }
        localStorage.setItem('temp_data',  JSON.stringify(tempdata));
        this.setState({selected_user_ary:tempdata});
    } 

    handleCheckSelectedUserExistOrNot(val) {
        return this.state.selected_user_ary.some(item => val == item);
    }

    removeMultiUserId(id){
        var tempdata = JSON.parse(localStorage.getItem('temp_data'));
        var array = tempdata; // make a separate copy of the array
        var index = array.indexOf(id.toString());
        if (index !== -1) {
            array.splice(index, 1);
        }
        tempdata = array;
        localStorage.setItem('temp_data',  JSON.stringify(tempdata));
        this.setState({selected_user_ary:tempdata});
    }    

    getTimeStampList = (selected_date, resolve) =>{
        this.setState({total_count:-1,timestamp_data:[],is_loading:true});
        if(this.state.terminal_id === ''){
            var terminal_id = (localStorage.getItem('active_terminal') === null) ? '' : JSON.parse(localStorage.getItem('active_terminal')).terminal_unique_id;
        }else{
            terminal_id = this.state.terminal_id;
        }
      var formData=new FormData();
      formData.append("terminal_id", terminal_id);
      formData.append("user_id", localStorage.getItem('userid'));
      formData.append("department_id",localStorage.getItem('department_id'));
      formData.append("start_date",selected_date);
      formData.append("end_date",selected_date);
      post(Constent.TERMINALGETTIMESTAMP,formData).then(response=>{
          this.setState({is_loading:false});
          if(response.status===1){
            this.setState({
                timestamp_data:response.users,
                total_count:response.users.length,
                emp_edit: response.read_write,
                selected_date: response.start_date,
                meeting_date: response.start_date,
                custom_date: response.custom_date,
                grand_total_time: response.total_time,
                terminal_id : response.terminal_data.terminal_unique_id,
                terminal_description : response.terminal_data.terminal_description,
                to_do : response.terminal_data.to_do,
                export_type : response.terminal_data.export_type,
                is_device_online : response.terminal_data.is_device_online,
            })
            localStorage.setItem('active_terminal',JSON.stringify(response.terminal_data));
            this.enableNextButton(response.end_date);
                window['modalClose']();
          }else{
            Alert.error({title: response.message});
          }
          if(resolve) {
            resolve();
          }
      })
    }

    getTimeStampDetail = (userId,date) => {
        this.setState({selected_date:date});
            var formData=new FormData();
            formData.append("user_id",userId);
            formData.append("selected_date",date);
            post(Constent.GetTimeStampDetail,formData).then(response=>{
                if( response.status===1 ){
                  var data=response.data;
                  this.setState({
                      timestamp_details:data,
                      date:date,
                      user_id:userId
                  })
                }
          })
      }

    addTimestamp = () => {
        var meeting_date= this.state.meeting_date;
            meeting_date= meeting_date.split("-"); //convert 'jQuery' to array
            meeting_date = meeting_date.reverse(); //reverse 'jQuery' order 
            meeting_date = meeting_date.join("-");  

        var startDateTime = meeting_date + ' ' + this.state.meeting_time,
            endDateTime = meeting_date + ' ' + this.state.leaving_time;
            startDateTime = moment(startDateTime, 'DD-MM-YYYY HH:mm');
            endDateTime = moment(endDateTime, 'DD-MM-YYYY HH:mm');
            if (endDateTime.isBefore(startDateTime)) {
                endDateTime = endDateTime.add(1, "days");
            }
        var leaving_date = moment(endDateTime).format('DD-MM-YYYY'); 

        var formData=new FormData();

        formData.append("terminal_id",this.state.terminal_id);
        formData.append("latitude",location.latitude);
        formData.append("longitude",location.longitude);
        formData.append("meeting_date",meeting_date);
        formData.append("meeting_time",this.state.meeting_time);
        formData.append("leaving_date",leaving_date);
        formData.append("leaving_time", (this.state.leaving_time === '00:00' ? '' : this.state.leaving_time ));
        formData.append("note",this.state.note);
        formData.append("user_ids",this.state.selected_user_ary);
        formData.append("deviceType","mobile manually");
        formData.append("selected_date",this.state.meeting_date);
        post(Constent.TERMINALADDTIMESTAMP,formData).then(response=>{
            if(response.flag===1){
                window['modalClose']();
                Alert.success({title: response.msg});
                localStorage.setItem('temp_data', JSON.stringify([]));
               this.getTimeStampList(this.state.selected_date);
            }else{
              Alert.error({title: response.msg});
            }
        })
    };


     updateTimestamp = () => {
        var meeting_date= this.state.meeting_date;
        meeting_date= meeting_date.split("-"); //convert 'jQuery' to array
        meeting_date = meeting_date.reverse(); //reverse 'jQuery' order 
        meeting_date = meeting_date.join("-");  

        var startDateTime = meeting_date + ' ' + this.state.meeting_time,
        endDateTime = meeting_date + ' ' + this.state.leaving_time;
        startDateTime = moment(startDateTime, 'DD-MM-YYYY HH:mm');
        endDateTime = moment(endDateTime, 'DD-MM-YYYY HH:mm');
        if (endDateTime.isBefore(startDateTime)) {
            endDateTime = endDateTime.add(1, "days");
        }
        var leaving_date = moment(endDateTime).format('DD-MM-YYYY');   

        var formData=new FormData();
           formData.append("timestamp_detail_id", this.state.timestamp_detail_id);
           formData.append("meeting_date",meeting_date);
           formData.append("meeting_time",this.state.meeting_time);
           formData.append("leaving_date",leaving_date);
           formData.append("leaving_time", (this.state.leaving_time === '00:00' ? '' : this.state.leaving_time ));
           formData.append("note",this.state.note);
           formData.append("user_id",this.state.user_id);
           formData.append("date",this.state.meeting_date);
           
       post(Constent.EDITTIMESTAMP,formData).then(response=>{
            window['modalClose']();
            if(response.status===1){
                Alert.success({title: response.msg});
                this.getTimeStampList(this.state.selected_date);
            }else{
                Alert.error({title: response.msg});
           }
       })
     };

handledelet = () => {
   var formData=new FormData(); 
   formData.append("user_id",this.state.user_id);
   formData.append("timestamp_detail_id",this.state.timestamp_detail_id);
   post(Constent.DELETIMESTAMEDETAIL,formData).then(response=>{
      if(response.status===1){
        window['modalClose']();
        Alert.success({title: response.msg});
        this.getTimeStampList(this.state.selected_date);
       }else{
            Alert.error({title: response.msg});
       }
   })  
 };
    

    getDuration = (meet, leave) => {
    if( (leave !== '00:00') && (leave !== '') ){
    var newDt=this.state.timerec.trim().split("-");
   // var sldat=newDt[1].toString().trimLeft();

    var meetDate = newDt[2]+"-"+newDt[1]+"-"+newDt[0].trim();
    
    var startDateTime = meetDate + ' ' + meet,
          endDateTime = meetDate + ' ' + leave;
        
        startDateTime = moment(startDateTime, 'DD-MM-YYYY HH:mm');
        endDateTime = moment(endDateTime, 'DD-MM-YYYY HH:mm');
        if (endDateTime.isBefore(startDateTime)) {
            endDateTime = endDateTime.add(1, "days");
        }
      //  var duration = endDateTime.diff(startDateTime, "hours");
      //  var newLeaveDate = moment(endDateTime).format('DD-MM-YYYY');
        
        // start added by srb - for hour and milute also
        var hourDiff = endDateTime - startDateTime; //in ms
      //  var secDiff = hourDiff / 1000; //in s
        var minDiff = hourDiff / 60 / 1000; //in minutes
        var hDiff = hourDiff / 3600 / 1000; //in hours
        var humanReadable = {};
        humanReadable.hours = Math.floor(hDiff);
        humanReadable.minutes = minDiff - 60 * humanReadable.hours;
        var diffTime =  humanReadable.hours + ':' + humanReadable.minutes;
        //console.log(humanReadable); //{hours: 0, minutes: 30}
        this.setState({total_time:diffTime});
      }else{  
          this.setState({total_time:'00:00'});
        }
    };

    getDeviceList(){
        var formData=new FormData();
        formData.append("department_id",localStorage.getItem('department_id'));
        if(localStorage.getItem('user_type') !== 'department'){  
            formData.append("guest_id",localStorage.getItem('userid'));
            var email = (localStorage.getItem('user_data') === null) ? '' : JSON.parse(localStorage.getItem('user_data')).email;
            formData.append("guest_email_id",email);
        }
      post(Constent.DEVICELIST,formData).then(response=>{
          if(response.status){
            this.setState({device_list:response.data, total_terminal: response.data.length}) ;
          }else{
            Alert.error({title: response.message});
          }
      })
    }

    handleSendMsg = () => {
        var formData=new FormData();
        formData.append("user_id",localStorage.getItem('userid'));
        formData.append("selected_user",this.state.selected_user);
        formData.append("date",this.state.date);
        formData.append("message",this.state.message);
        post(Constent.SENDMESSAGE,formData).then(response =>{
          if(response.status===1){
            window['modalClose']();
            Alert.success({title: response.message});
          }else{
            Alert.error({title: response.message});
          }
        })
    };

    updateDevice = () => {
        var formData=new FormData();
        formData.append("id",(localStorage.getItem('active_terminal') === null) ? '' : JSON.parse(localStorage.getItem('active_terminal')).id);
        formData.append("user_id",localStorage.getItem('userid'));
        formData.append("description",this.state.terminal_description);
        formData.append("to_do",this.state.to_do);
        formData.append("export_type",this.state.export_type);
        formData.append("password",this.state.password);
        post(Constent.UPDATEDEVICE,formData).then(response =>{
          if(response.status===1){
            window['modalClose']();
            Alert.success({title: response.message});
          }else{
            Alert.error({title: response.message});
          }
        })
    };



    selectDropdown = (val) => {
        if(val === 'send_message'){
            this.setState({selected_user: '',date:'',message:''});
            window['modalOpen']('#send-message-modal');
        }else if(val === 'notice_board'){
            window['modalOpen']('#notice-board-modal');
        }else if(val === 'device_settting'){
            window['modalOpen']('#device-setting-modal');
        }else if(val === 'share_device'){
            this.getShareDeviceData();
            window['modalOpen']('#share-device-modal');
        }else{

        }
        this.setState({select_dropdown:''});
    };

    changeTerminal = (val,msgtext,btntext) => {
        Alert.confirm({
            position:'toast-top-full-width',
            message: msgtext,
            btn_yes: btntext,
            action: (e) =>{
                this.setState({'terminal_id':val});
                this.getTimeStampList(this.state.selected_date)
            }
        })
    
    };

    getShareDeviceData = () =>{
        if(this.state.terminal_id === ''){
            var terminal_id = (localStorage.getItem('active_terminal') === null) ? '' : JSON.parse(localStorage.getItem('active_terminal')).terminal_unique_id;
        }else{
            terminal_id = this.state.terminal_id;
        }
      var formData=new FormData();
      formData.append("terminal_id", terminal_id);
      formData.append("department_id",localStorage.getItem('department_id'));
      post(Constent.GETSHAREDEVICEDATA,formData).then(response=>{
          if(response.status===1){
            this.setState({
                share_device_data:response.data,
            })
          }else{
            Alert.error({title: response.message});
            window['modalOpen']('#share-device-modal');
          }
      })
    }

    shareDeviceUpdate = (type,id) => {
        if(this.state.terminal_id === ''){
            var terminal_id = (localStorage.getItem('active_terminal') === null) ? '' : JSON.parse(localStorage.getItem('active_terminal')).terminal_unique_id;
        }else{
            terminal_id = this.state.terminal_id;
        }
        var formData=new FormData();
        formData.append("terminal_id", terminal_id);
        formData.append("id", id);
        formData.append("type", type);

        post(Constent.guestShareUpdateSettings,formData).then(response =>{
          if(response.status===1){
            this.getShareDeviceData();
            Alert.success({title: response.message});
          }else{
            Alert.error({title: response.message});
          }
        })
    };

    addBreak = () => {
        var meeting_date= this.state.meeting_date;
            meeting_date= meeting_date.split("-"); //convert 'jQuery' to array
            meeting_date = meeting_date.reverse(); //reverse 'jQuery' order 
            meeting_date = meeting_date.join("-");  

        var startDateTime = meeting_date + ' ' + this.state.meeting_time,
            endDateTime = meeting_date + ' ' + this.state.leaving_time;
            startDateTime = moment(startDateTime, 'DD-MM-YYYY HH:mm');
            endDateTime = moment(endDateTime, 'DD-MM-YYYY HH:mm');
            if (endDateTime.isBefore(startDateTime)) {
                endDateTime = endDateTime.add(1, "days");
            }
        var formData=new FormData();
       formData.append("timestamp_id",this.state.timestamp_id);
       formData.append("break-from[]",this.state.meeting_time);
       formData.append("break-to[]", (this.state.leaving_time === '00:00' ? '' : this.state.leaving_time ));
       post(Constent.ADDTIMESTAMPBREAK,formData).then(response=>{
          if(response.flag===1){
              window['modalClose']();
              Alert.success({title: response.msg});
             this.getTimeStampList(this.state.selected_date);
           }else{
             Alert.error({title: response.msg});
           }
       })
     };

     updateBreak = () => {
       var formData=new FormData();
       formData.append("primary_key",this.state.primary_key);
       formData.append("break-from",this.state.meeting_time);
       formData.append("break-to", (this.state.leaving_time === '00:00' ? '' : this.state.leaving_time ));
       post(Constent.UPDATETIMESTAMPBREAK,formData).then(response=>{
          if(response.flag===1){
              window['modalClose']();
              Alert.success({title: response.msg});
             this.getTimeStampList(this.state.selected_date);
           }else{
             Alert.error({title: response.msg});
           }
       })
     };

     changeCheckIn = (checkInStatus) => {
        this.setState({checkInStatus: checkInStatus});
    }

    render() {
        const { t } = this.props;
        return (
        <>
                { helpers.isIntegrationExpired(10) ? <PackageExpired /> : '' }
                {/* Header Starts */}
                <div className="header-area timeregistraionpage" style={{'borderRadius': 0}}>
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-3 col-3">
                                <Link className="menu-back-page home-clicked" to={'/'}>
                                    <i className="fa fa-home" />
                                </Link>
                            </div>
                            <div className="col-sm-6 col-6 text-center">
                                <div className="page-name">{t('lang.terminal_sc_attendence_device')}</div>
                            </div>
                            <div className="col-sm-3 col-3 text-right">
                               <HeaderRight />
                            </div>
                        </div>
                    </div>
                </div>

                <div className=" mg-top-50 sub-header">
                    <div className="container">
                        <div className="row action-row">
                            <div className="col-6" style={{ paddingTop: 5}}>
                                <span className="previous"
                                onClick={() => {
                                  var date1 = new Date(this.state.selected_date);
                                    date1.setDate(date1.getDate()-1);
                                    var neweDate=date1.toISOString();
                                    neweDate=neweDate.split("T");
                                    this.setState({selected_date:neweDate[0]});
                                    this.getTimeStampList(neweDate[0],neweDate[0], this.state.group_id,this.state.filter_type);
                                    }}>{t('lang.filter_text_prev')}</span>
                                {this.state.enable_next_button === true ?    
                                <span className="next"
                                    onClick={() => {
                                    var date1 = new Date(this.state.selected_date);
                                    date1.setDate(date1.getDate() + 1)
                                    var neweDate=date1.toISOString();
                                    neweDate=neweDate.split("T");
                                    this.setState({selected_date:neweDate[0]});
                                    this.getTimeStampList(neweDate[0],neweDate[0],this.state.group_id,this.state.filter_type);
                                    }}>{t('lang.filter_text_next')}</span> : ''}
                            </div>
                            <div className="col-6 text-right">
                            <span>{ this.startdt()}</span>
                                &nbsp;&nbsp;<i className="las la-calendar" style={{fontSize:23}} data-toggle="modal" data-target="#calendar-modal"></i> <br></br>
                            { (localStorage.getItem('user_type') === 'department') ? <>
                                <select id="attandanceDropdown" 
                                onChange={e => { this.selectDropdown(e.target.value)}}
                                value={this.state.select_dropdown}>
                                    <option value="">{t('lang.terminal_menu_sc_select_option')}</option>
                                    <option value="send_message">{t('lang.terminal_menu_sc_send_message')}</option>
                                    <option value="notice_board">{t('lang.terminal_menu_sc_notice_board')}</option>
                                    <option value="share_device">{t('lang.terminal_menu_sc_share_device')}</option>
                                    <option value="device_settting">{t('lang.terminal_menu_sc_device_settings')}</option>
                                </select> </> : ''}
                            </div>
                        </div>
                    </div>
                </div>

                <PullToRefresh
                        pullDownContent={<PullDownContent label='' />}
                        releaseContent={false}
                        refreshContent={<RefreshContent />}
                        pullDownThreshold={2}
                        onRefresh={this.handleRefresh}
                        triggerHeight={500}
                        startInvisible= {true}
                    >
                <div className="timeregistraion-userlistpage transaction-area mg-bottom-40">
                    <select className="form-control" style={{background:'#E6E6E6',broder:'1px solid #CCCCCC',marginBottom:10}}
                        value={this.state.terminal_id}
                        onChange={e => { this.changeTerminal(e.target.value,t('lang.message_are_you_sure'),t('lang.btn_text_yes_do_it'))}}
                    >
                        <option value="">{t('lang.terminal_menu_sc_select_option')}</option>
                        { this.state.device_list.map(({ id, device_id, description,to_do,is_device_online }) => (
                            <option value={device_id} key={id}>{device_id} | {(is_device_online === 1) ? 
                             t('lang.terminal_sc_online') : t('lang.terminal_sc_offline')
                            }</option>
                        ))}
                    </select>

                    {(this.state.is_loading) ? <p className="text-center">{t('lang.common_text_loading') }</p> : 
                    <div className="row dateview" key={'00'}>
                        <div className="col-5">
                            <span>{this.state.custom_date}</span>
                        </div>
                        <div className="col-7  text-right">
                            <span>{t('lang.terminal_sc_hours_of_the_day')}  : {this.state.grand_total_time}</span>
                        </div>
                    </div> }
                    { (this.state.total_count === 0) ? <span className="center">{t('lang.message__no_record_available')} </span> : ''}             
                    {this.state.timestamp_data.map(({ timestamp_id,user_id,image,group_name,job_title,full_name,meetTime,leaveTime,totalTime}) => (
                        <div key={Math.random()}>
                       
                        <div className="ba-single-transaction" key={ timestamp_id }>
                        <Link style={{ width:'100%' }} to={'#'} 
                            data-toggle="modal" data-target="#timestamp-details-modal" 
                            onClick={()=> { this.getTimeStampDetail(user_id, this.state.selected_date); this.setState({timestamp_id:timestamp_id,user_id:user_id,timestamp_details:[]}) }}>
                            <div className="row" data-toggle="modal" data-target="#timedetails-modal">
                                <div className="col-2 pd-right-0">
                                    <img src={image} alt="img" style={{width: 50,height: 50}}/>
                                </div>
                                <div className="col-5">
                                    <h6 className="text-overflow">{full_name}</h6>
                                    <p>{group_name}</p>
                                    <p>{job_title}</p>
                                </div>
                                
                                <div className="col-5 text-right">
                                    <p>{moment(meetTime, "YYYY-MM-DD HH:mm").format("HH:mm")}-{(leaveTime === '')? '': moment(leaveTime, "YYYY-MM-DD HH:mm").format("HH:mm")}</p>
                                    {(leaveTime === '')? '' :
                                    <p className="hours">{t('lang.common_text_hours')}: <strong>{totalTime}</strong></p>
                                    }
                                    {(leaveTime === '') ?
                                     <p className="working"> <i className="fa fa-circle"></i> {t('lang.flex_sc_working')}</p>
                                    :''}
                                </div>

                            </div>
                            </Link>
                        </div>
                        
                        </div>
                        ))}                 
                    
                </div>
                </PullToRefresh>
                {/* transaction End */}

            {/* Footer start */}
                <div className="footer-area">
                    <div className="container">
                        <div className="footer-bottom text-center">
                            <div className="row center">
                                <div className="col-9 ">
                                    
                                </div>
                                <div className="col-3">
                                    <Link className="home-clicked" to={'/'}>
                                        <i className="fa fa-home" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            {/* Footer End */}

            {/* Check in popip end  */}
                <CheckinPopup setCheckInStatus = {this.changeCheckIn}  checkinoutScreen="time" p_userid={localStorage.getItem('userid')}/>
            {/* Checkin popup end  */}

            {((localStorage.getItem('user_type') !== 'user') && (this.state.emp_edit === 1) )?
            <Link to={'#'} className="add-btn-right" 
            data-toggle="modal" data-target="#add-timestamp-modal"
            onClick={()=>{
              this.setState({
                meeting_date:this.state.selected_date,
                meeting_time:'',
                leaving_time:'',
                note:'',
                timestamp_detail_id: '',
                user_id:'',
                selected_user_ary: []
            });
               localStorage.setItem('temp_data', JSON.stringify([]));
            }}
            >
                <i className="las la-plus"></i>
            </Link>
            :''}

            {/*  calendar-modal start */}
            <div id="calendar-modal" className="modal fade" style={{top: 0,bottom: 'auto'}}>
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{t('lang.shift_sc_shift')} {moment(this.state.date, "YYYY-MM-DD").format("DD MMM YYYY")}</h5>
                           
                            <div className="modal-close" data-dismiss="modal">
                                <i className="la la-times" />
                            </div>
                        </div>
                        <div className="modal-body">
                            <div className="action-sheet-content">
                                <div className="input-group">
                                    <input type="date" value={this.state.date} className="datecalander form-control form-control-lg"
                                    onChange={e => { this.setState({date: e.target.value}); this.getTimeStampList(e.target.value, e.target.value); window['modalClose'](); }}/>
                                </div>
                            </div>  
                        </div>  
                    </div>  
                </div>     
            </div>
            {/* Timeregistration details modal  start  */}
            <div id="timedetails-modal" className="modal modal-top fade">
                <div className="modal-dialog" role="document">
                    <div className="modal-content" style={{'background':'#F5F5F5'}}>
                        <div className="modal-header">
                            <h5 className="modal-title">Stamp of {this.state.date.substring(0,3)} {this.state.date.substring(6,20).replaceAll('-','/')}</h5>
                            <div className="modal-close" data-dismiss="modal">
                                <i className="la la-times" />
                            </div>
                        </div>
                        <div className="modal-body" style={{'paddingRight':0,'paddingLeft':0}}>
                        { (this.state.timestamp_details.length > 0) ? 
                            <div className="row" style={{'marginRight': 0,'marginLeft': 0}}>
                                  <div className="col-2">
                                  </div>
                                  <div className="col-3">
                                    {t('lang.timestamp_sc_meet')} 
                                  </div>
                                  <div className="col-3">
                                    {t('lang.timestamp_sc_leave')}
                                  </div>
                                  <div className="col-4">
                                    {t('lang.timestamp_sc_time')}
                                  </div>
                            </div>
                        : <div className="col-12 text-center">{t('lang.message__no_record_available')}</div> }      
                        {this.state.timestamp_details.map(({ id,type,timestamp_detail_id, date, timestamp_id, user_id, meeting, leaving, note,total_ime,meet_image, leave_image, browser, leave_browser, index}) => (
                            <div className="single-goal" key={timestamp_detail_id} style={{'paddingTop': 10,'paddingBottom': 10}}>
                                <div className="row" style={{'marginRight': 0,'marginLeft': 0}}>
                                  <div className="col-2 center">
                                  {type !== 'break' ? 
                                    <i className="las la-clock time-icon bg-theme"></i>
                                    : <i className="las la-coffee break-icon"></i>}
                                  </div>
                                  
                                    <div className={ (type === 'break') ? 'col-8 mgTp13' : 'col-8'} >
                                        <div className="row">

                                            <div className="col-4" style={{'textDecoration': 'underline'}}>
                                                <Link to={'#'} 
                                                data-toggle="modal" data-target={type !== 'break' ? '#edit-timestamp-modal' : '#edit-break-modal'}
                                                onClick={()=>{
                                                  this.setState({
                                                    primary_key: id,
                                                    meeting_date:this.state.selected_date,
                                                    meeting_time:meeting,
                                                    leaving_time:leaving,
                                                    note:note,
                                                    timestamp_detail_id: timestamp_detail_id
                                                    })
                                                }}>
                                                    {meeting} 
                                                </Link>
                                            </div>
                                            <div className="col-4 text-center" style={{'textDecoration': 'underline'}}
                                            data-target="#edit-timestamp-modal" >
                                                <Link to={'#'} 
                                                data-toggle="modal" data-target={type !== 'break' ? '#edit-timestamp-modal' : '#edit-break-modal'}
                                                onClick={()=>{
                                                  this.setState({
                                                    primary_key: id,
                                                    meeting_date:this.state.selected_date,
                                                    meeting_time:meeting,
                                                    leaving_time:leaving,
                                                    note:note,
                                                    timestamp_detail_id: timestamp_detail_id})
                                                }}>
                                                { (leaving !== '') ? leaving : '--:--' }
                                                </Link>
                                            </div>
                                            <div className="col-4 text-center">
                                                <span className="color-green">{ total_ime }</span>
                                            </div>

                                            {type !== 'break' ? 
                                            <div className="col-12" style={{'marginTop': 7,'marginBottom': 7}}>
                                                <input type="text" value={note} placeholder={t('lang.flex_sc_the_note_here') } style={{width:'100%'}} readOnly={true}
                                                data-toggle="modal" data-target={type !== 'break' ? '#edit-timestamp-modal' : '#edit-break-modal'}
                                                onClick={()=>{
                                                  this.setState({
                                                    primary_key: id,
                                                    meeting_date:this.state.selected_date,
                                                    meeting_time:meeting,
                                                    leaving_time:leaving,
                                                    note:note,
                                                    timestamp_detail_id: timestamp_detail_id})
                                                }} />
                                            </div> : ''}
                                        </div>
                                    </div>
                                    <div className="col-2">
                                    {(this.state.emp_edit === 1) ? <>
                                        <i className="las la-times-circle clear-icon" 
                                        onClick={()=>{
                                          if( helpers.isIntegrationExpired(localStorage.getItem('integration_id'))){
                                            this.handleExpireOpen();
                                        }else{
                                            Alert.delete({
                                                position:'toast-top-full-width',
                                                message:t('lang.message_this_data_wont_be_retrievable_once_deleted_are_you_sure'),
                                                btn_yes:t('lang.btn_text_yes_do_it'),
                                                action: () =>{   
                                                    this.setState({ timestamp_detail_id:timestamp_detail_id })
                                                    this.handledelet();
                                                }
                                            })
                                        }
                                        }}></i>
                                    </> : ''}
                                  </div>  
                                </div>
                            </div>
                        ))}   
                           
                        </div>
                        <div className="form-group basic center footer-action">
                            {(this.state.emp_edit === 1) ? <>
                                { (this.state.timestamp_details.length > 0) ?
                                <Link to={'#'} className="add-break-btn center" 
                                    data-toggle="modal" data-target="#add-break-modal"
                                    onClick={()=>{
                                      this.setState({
                                        meeting_time:'',
                                        leaving_time:''})
                                    }}
                                    >
                                    <i className="las la-coffee"></i>{t('lang.timestamp_sc_add_break') }
                                </Link>
                                : ''}
                                <Link to={'#'} className="add-record-btn center" 
                                    data-toggle="modal" data-target="#add-timestamp-modal"
                                    onClick={()=>{
                                      this.setState({
                                        meeting_date:this.state.selected_date,
                                        meeting_time:'',
                                        leaving_time:'',
                                        note:'',
                                        timestamp_detail_id: ''})
                                        localStorage.setItem('temp_data', JSON.stringify([]) );
                                        this.setState({selected_user_ary:[this.state.user_id]});
                                    }}
                                    >
                                    <i className="las la-plus"></i> {t('lang.common_text_add_record') }
                                </Link>
                            </> : ''}
                        </div>
                    </div>
                </div>
              </div>  
            {/* Timeregistration details modal end  */}


            {/*  edit-timestamp-modal start */}
            <div id="edit-timestamp-modal" className="modal fade">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{t('lang.timestamp_sc_edit_timestamp')}</h5>
                            <div className="modal-close" data-dismiss="modal">
                                <i className="la la-times" />
                            </div>
                        </div>
                        <div className="modal-body">
                            <div className="action-sheet-content">
                            {(this.state.emp_edit === 1) ? <>   
                                <span className="label">{t('lang.timestamp_sc_meeting_time')}</span>
                                <div className="input-group mb-4">
                                    <input type="time" className="form-control form-control-lg"
                                    value={this.state.meeting_time} 
                                    onChange={e => { this.setState({meeting_time: e.target.value})}} />
                                </div>

                                <span className="label">{t('lang.timestamp_sc_leaving_time')}</span>
                                <div className="input-group mb-4">
                                    <input type="time" className="form-control form-control-lg"
                                    value={this.state.leaving_time} 
                                    onChange={e => { this.setState({leaving_time: e.target.value})}} />
                                </div>
                                </> : ''}
                                <span className="label">{t('lang.timestamp_sc_note')}</span>
                                <div className="input-group mb-4">
                                    <input type="text" className="form-control form-control-lg"
                                    value={this.state.note} 
                                    onChange={e => { this.setState({note: e.target.value})}} />
                                </div>

                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn-c btn-success btn-block mb-2" onClick={()=>{this.updateTimestamp()}}>{t('lang.modal_btn_save')}</button>
                        </div>
                    </div>
                </div>
            </div>

            {/*  add-break-modal start */}
            <div id="add-break-modal" className="modal fade">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{t('lang.timestamp_sc_add_break')}</h5>
                            <div className="modal-close" data-dismiss="modal">
                                <i className="la la-times" />
                            </div>
                        </div>
                        <div className="modal-body">
                            <div className="action-sheet-content">
                               
                                <span className="label">{t('lang.timestamp_sc_meeting_time')}</span>
                                <div className="input-group mb-4">
                                    <input type="time" className="form-control form-control-lg"
                                    value={this.state.meeting_time} 
                                    onChange={e => { this.setState({meeting_time: e.target.value})}} />
                                </div>

                                <span className="label">{t('lang.timestamp_sc_leaving_time')}</span>
                                <div className="input-group mb-4">
                                    <input type="time" className="form-control form-control-lg"
                                    value={this.state.leaving_time} 
                                    onChange={e => { this.setState({leaving_time: e.target.value})}} />
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn-c btn-success btn-block mb-2" onClick={()=>{this.addBreak()}}>{t('lang.modal_btn_save')}</button>
                        </div>
                    </div>
                </div>
            </div>

             {/*  edit-break-modal start */}
            <div id="edit-break-modal" className="modal fade">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{t('lang.timestamp_sc_edit_break')}</h5>
                            <div className="modal-close" data-dismiss="modal">
                                <i className="la la-times" />
                            </div>
                        </div>
                        <div className="modal-body">
                            <div className="action-sheet-content">
                               
                                <span className="label">{t('lang.timestamp_sc_meeting_time')}</span>
                                <div className="input-group mb-4">
                                    <input type="time" className="form-control form-control-lg"
                                    value={this.state.meeting_time} 
                                    onChange={e => { this.setState({meeting_time: e.target.value})}} />
                                </div>

                                <span className="label">{t('lang.timestamp_sc_leaving_time')}</span>
                                <div className="input-group mb-4">
                                    <input type="time" className="form-control form-control-lg"
                                    value={this.state.leaving_time} 
                                    onChange={e => { this.setState({leaving_time: e.target.value})}} />
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                        {(this.state.emp_edit === 1) ? <>
                            <button type="button" className="btn-c btn-success btn-block mb-2" onClick={()=>{this.updateBreak()}}>{t('lang.modal_btn_save')}</button>
                        </> : ''}   
                        </div>
                    </div>
                </div>
            </div>

            {/*  send-message-modal start */}
            <div id="send-message-modal" className="modal fade">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{t('lang.terminal_sc_send_message')}</h5>
                            <div className="modal-close" data-dismiss="modal">
                                <i className="la la-times" />
                            </div>
                        </div>
                        <div className="modal-body">
                            <div className="action-sheet-content">
                               
                                <span className="label">{t('lang.shift_sc_select_employee')}</span>
                                <div className="input-group mb-4">
                                    <select className="form-control form-control-lg"
                                        value={this.state.selected_user}
                                        onChange={e => { this.setState({selected_user: e.target.value})}}>
                                      <option>{t('lang.shift_sc_select_employee')}</option>
                                      {this.state.user_list.map(({ id,first_name, last_name }) => (
                                        <option value={id} key={id}>{first_name} {last_name}</option>
                                      ))}
                                    </select>
                                </div>

                                <span className="label">Date</span>
                                <div className="input-group mb-4">
                                    <input type="date" className="form-control form-control-lg"
                                    min={helpers.getCurrentDate()}
                                    onChange={e => { this.setState({date: e.target.value})}} />
                                </div>

                                <span className="label">Message</span>
                                <div className="input-group mb-4">
                                    <textarea className="form-control form-control-lg" 
                                    defaultValue={this.state.message}
                                    onChange={e => { this.setState({message: e.target.value})}}>
                                    </textarea>
                                </div>

                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn-c btn-success btn-block mb-2" onClick={()=>{this.handleSendMsg()}}>{t('lang.modal_btn_send')}</button>
                        </div>
                    </div>
                </div>
            </div>  

            {/*  notice-board-modal start */}
            <div id="notice-board-modal" className="modal fade">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{t('lang.terminal_menu_sc_notice_board')}</h5>
                            <div className="modal-close" data-dismiss="modal">
                                <i className="la la-times" />
                            </div>
                        </div>
                        <div className="modal-body">
                            <div className="action-sheet-content">
                                <span className="label">{t('lang.chat_sc_message')}</span>
                                <div className="input-group mb-4">
                                    <textarea className="form-control form-control-lg" 
                                    defaultValue={this.state.to_do}
                                    onChange={e => { this.setState({to_do: e.target.value})}}>
                                    </textarea>
                                </div>

                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn-c btn-success btn-block mb-2" onClick={()=>{this.updateDevice()}}>{t('lang.modal_btn_send')}</button>
                        </div>
                    </div>
                </div>
            </div>   

        {/*  device-setting-modal start */}
            <div id="device-setting-modal" className="modal fade">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{t('lang.terminal_menu_sc_device_settings')} ({this.state.terminal_id})</h5>
                            <div className="modal-close" data-dismiss="modal">
                                <i className="la la-times" />
                            </div>
                        </div>
                        <div className="modal-body">
                            <div className="action-sheet-content">
                                <span className="label">{t('lang.terminal_sc_description')}</span>
                                <div className="input-group mb-4">
                                    <textarea className="form-control form-control-lg" 
                                    defaultValue={this.state.terminal_description}
                                    onChange={e => { this.setState({terminal_description: e.target.value})}}>
                                    </textarea>
                                </div>
                                
                                <span className="label">{t('lang.employee_sc_password')}</span>
                                <div className="input-group mb-4">
                                    <input type="password" placeholder="*****" className="form-control form-control-lg" 
                                    value={this.state.password}
                                    onChange={e => { this.setState({password: e.target.value})}} />
                                </div>

                                <span className="label">{t('lang.terminal_sc_export_to')}</span>
                                <select className="form-control form-control-lg"
                                    onChange={e => { this.setState({export_type : e.target.value})}}
                                    value={this.state.export_type}>
                                        <option value="pdf">{t('lang.common_text_pdf')}</option>
                                        <option value="excel">{t('lang.common_text_excel')}</option>
                                </select>
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn-c btn-success btn-block mb-2" onClick={()=>{this.updateDevice()}}>{t('lang.modal_btn_send')}</button>
                        </div>
                    </div>
                </div>
            </div>  

        {/* Share Device    */}
            <div id="share-device-modal" className="home-page modal modal-top fade">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{t('lang.terminal_menu_sc_share_device')}</h5>
                            <div className="modal-close" data-dismiss="modal">
                                <i className="la la-times" />
                            </div>
                        </div>
                        <div className="modal-body">
                            <div>
                                <ul className="transaction-details-inner">
                                { (this.state.share_device_data.length === 0) ? <span className="center">{t('lang.message__no_record_available')}</span> : ''}
                                    { this.state.share_device_data.map(({  id,full_name, email_id, invitation_status,permission,status }) => (
                                    <li key={id}>
                                        <span className="text-overflow"> <small>{email_id}</small> <br/> {full_name}</span>
                                        <div className="row">
                                        <div className="col-3 link">
                                            <Link to={'#'} onClick={e => { 
                                                Alert.confirm({
                                                position:'toast-top-full-width',
                                                message: t('lang.message_are_you_sure_to_change_the_status'),
                                                btn_yes: t('lang.btn_text_yes_do_it'),
                                                action: () =>{   
                                                    this.shareDeviceUpdate('status',id)
                                                }
                                                })
                                            }} > {status === 1 ? t('lang.common_text_active') : t('lang.common_text_inactive') } </Link>
                                        </div>
                                        <div className="col-6 link text-center">
                                            <Link to={'#'} onClick={e => { 
                                                Alert.confirm({
                                                position:'toast-top-full-width',
                                                message: t('lang.message_are_you_sure_to_change_the_permission'),
                                                btn_yes: t('lang.btn_text_yes_do_it'),
                                                action: () =>{   
                                                    this.shareDeviceUpdate('permission',id)
                                                }
                                                })
                                            }} > {permission === 1 ? t('lang.permission_message_read_and_write') : t('lang.permission_message_read') } </Link>
                                        </div>
                                        <div className="col-3 link">
                                            <Link to={'#'} onClick={e => { 
                                                Alert.delete({
                                                position:'toast-top-full-width',
                                                message:t('lang.message_this_data_wont_be_retrievable_once_deleted_are_you_sure'),
                                                btn_yes:t('lang.btn_text_yes_do_it'),
                                                action: () =>{   
                                                    this.shareDeviceUpdate('delete',id)
                                                }
                                                })
                                            }} >{t('lang.modal_btn_delete')}</Link>
                                        </div>
                                        </div>
                                   
                                    </li>
                                    ))}
                                    </ul>
                            </div>
                        </div>
                    </div>
                </div>
              </div>  
            {/* Modal One end  */}

            {/*  add-timestamp-modal start */}
            <div id="add-timestamp-modal" className="modal fade">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{t('lang.timestamp_sc_add_timestamp')}</h5>
                            <div className="modal-close" data-dismiss="modal">
                                <i className="la la-times" />
                            </div>
                        </div>
                        <div className="modal-body">
                            <div className="action-sheet-content">
                               
                                <span className="label">{t('lang.timestamp_sc_meeting_date')}</span>
                                <div className="input-group mb-4">
                                    <input type="date" className="form-control form-control-lg"
                                    value={this.state.meeting_date}
                                    max={helpers.getCurrentDate()} 
                                    onChange={e => { this.setState({meeting_date: e.target.value})}} />
                                </div>

                                <span className="label">{t('lang.timestamp_sc_meeting_time')}</span>
                                <div className="input-group mb-4">
                                    <input type="time" className="form-control form-control-lg"
                                    value={this.state.meeting_time} 
                                    onChange={e => { this.setState({meeting_time: e.target.value})}} />
                                </div>

                                <span className="label">{t('lang.timestamp_sc_leaving_time')}</span>
                                <div className="input-group mb-4">
                                    <input type="time" className="form-control form-control-lg"
                                    value={this.state.leaving_time} 
                                    onChange={e => { this.setState({leaving_time: e.target.value})}} />
                                </div>

                                <span className="label">{t('lang.timestamp_sc_note')}</span>
                                <div className="input-group mb-4">
                                    <input type="text" className="form-control form-control-lg"
                                    value={this.state.note} 
                                    onChange={e => { this.setState({note: e.target.value})}} />
                                </div>

                                <>{this.state.user_list2.map((data,idx)=>(
                                    <div key={Math.random()}> 
                                        {this.state.selected_user_ary.some(item => data.id == item) ? 
                                        <div key={Math.random()} className="row" style={{background: '#FFFFFF', padding: 10,marginBottom: 5,textTransform: 'capitalize',fontSize: 20}}>
                                        <div className="col-8" >{data.first_name} {data.last_name}</div>
                                        <div className="col-4 text-right"> 
                                        <i onClick={e => {this.removeMultiUserId(data.id)} } className="fa fa-check-square" aria-hidden="true" style={{color: '#089953'}}></i> </div></div>
                                     : ''}
                                    </div>
                                ))}</>
                                <div className="input-group mb-4">
                                    <p className="link" data-toggle="modal" data-target="#add-employee-modal" ><i className="las la-plus"></i> {t('lang.shift_sc_add_employee')}</p>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                             <button type="button" className="btn-c btn-success btn-block mb-2" onClick={()=>{this.addTimestamp()}}>{t('lang.modal_btn_save')}</button>
                        </div>
                    </div>
                </div>
            </div>


            {/*  add-employee-modal start */}
            <div id="add-employee-modal" className="modal fade">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{t('lang.shift_sc_select_employee')}</h5>
                            <div className="modal-close" data-dismiss="modal">
                                <i className="la la-times" />
                            </div>
                        </div>
                        <div className="modal-body">
                            {this.state.user_list2.map(item=> (
                            <div key={Math.random()}  className="row" style={{background: '#FFFFFF', padding: 10,marginBottom: 5,textTransform: 'capitalize',fontSize: 20}}>
                            <label className="col-10" id={item.id} htmlFor={item.id+'_uchk'} style={{marginBottom:0}}>{item.first_name} {item.last_name} </label>
                            <div className="col-2 text-right" > 
                                <input type="checkbox" name="user_idsary"
                                id={item.id+'_uchk'} value={item.id} title={item.first_name +' '+item.last_name}
                                onChange={e => { this.handleChange(e)  }} 
                                checked={this.handleCheckSelectedUserExistOrNot(item.id)} />
                            </div></div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            </>
        );
    }
}

export default withTranslation('common')(DeviceTimestamp);